export enum KEYS_SESSION_STORAGE {
	'accountsOrigin' = 'accountsOrigin',
	'accountsDestination' = 'accountsDestination',
	'accountsListResume' = 'accountsListResume',
	'accountsListTermDeposit' = 'accountsListTermDeposit',
	'comboValues' = 'comboValues',
	'comboRegiones' = 'comboRegiones'
}

export enum CURRENCY {
	'PEN' = 'PEN',
	'USD' = 'USD'
}

export enum CURRENCY_VALUE {
	'SOLES' = 1,
	'DOLARES' = 2
}

export enum CURRENCY_SYMBOL {
	'SOLES' = 'S/',
	'DOLARES' = 'US$'
}

//key capthca v3
export enum Captcha {
	V3_SITE_KEY = '6Ld7TXEcAAAAAMh_1984IK_qSlM_DAigo8gxM1wF'
}

export enum IDENTITY_DOCUMENTS {
	'DNI' = 1,
	'C.E' = 4,
	'RUC' = 14
}

export enum WarningAlertModal {
	ACCEPT,
	CANCEL
}

export enum SHIPPING_WAY {
	'MOBILE' = '1',
	'EMAIL' = '2',
	'COORDINATE' = '3'
}

export enum FREQUENT_OPERATION_TYPE {
	'TRANSFER_BETWEEN_ACCOUNT' = 22,
	'TRANSFER_FROM_BANK_TO_PACIFICO' = 25,
	'TRANSFER_OTHER_ACCOUNT' = 23,
	'TRANSFER_BANK_TO_PACIFICO' = 24,
	'PAYMENT_CONTRIBUTION' = 29,
	'SERVICES_PAYMENT' = 28
}

export enum FIX_TERM_DEPLATYPE {
	'INDIVIDUAL' = 'Individual',
	'INDISTINTO' = 'Manc.Indistinto',
	'CONJUNTO' = 'Manc.Conjunto'
}
